import {
    Component,
    OnInit,
    ViewEncapsulation,
    ViewChild,
    EventEmitter,
    Input,
    Output,
    OnDestroy,
} from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { PropertiesService } from 'app/services/properties.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject, merge, from } from 'rxjs';
import {
    takeUntil,
    startWith,
    tap,
    switchMap,
    filter,
    map,
    debounceTime,
} from 'rxjs/operators';
import {
    AuthenticationService,
    OfficesService,
    DropdownsService,
} from 'app/services';
import { OwnersService } from 'app/services/owners.service';
import { AttachmentsService } from 'app/services/attachments.service';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { GetImageSrcPipe } from 'app/pipes/get-image-src.pipe';
import { Lightbox } from 'ngx-lightbox';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { GlobalFuntions } from 'app/_helpers';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TrafficLightComponent } from './traffic-light/traffic-light.component';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import {
    forEach,
    isEmpty,
    indexOf,
    includes,
    map as mapLodash,
    assignIn,
    orderBy,
    findLast,
    floor,
} from 'lodash';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { PropertiesDetailsViewComponent } from './properties-details-view/properties-details-view.component';
import { environment } from 'environments/environment';
import { AccountsService } from 'app/services/accounts.service';
import { RejectAccountComponent } from './reject-account/reject-account.component';
import { PropertyBookingsComponent } from '../property-bookings/property-bookings.component';
import { TimeLineDataService } from 'app/components/time-line/time-line-data.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { PropertiesSearchService } from 'app/services/properties-search.service';
import { VirtualTourCodeComponent } from './virtual-tour-code/virtual-tour-code.component';
import { AllPropertiesShowOnMapComponent } from 'app/components/all-properties-show-on-map/all-properties-show-on-map.component';
import { PropertiesPrintEmailComponent } from '../properties-print-email/properties-print-email.component';
import { isValid, differenceInYears } from 'date-fns';
import { PropertyDuplicationsComponent } from './property-duplications/property-duplications.component';
import { ViewingToursModalComponent } from 'app/main/activities/viewingTours/viewing-tours-modal/viewing-tours-modal.component';
import { CommonDialogComponent } from 'app/components/common-dialog/common-dialog.component';
import { CompaniesService } from 'app/services/companies.service';
import { BaseService } from 'app/_helpers/base/base.service';
import { PropertyReservationComponent } from './property-reservation/property-reservation.component';
import { QuickAddComponent } from 'app/main/master-data/accounts/quick-add/quick-add.component';
import { ClientRegistrationRequestComponent } from './client-registration-request/client-registration-request.component';

import { ShowReasonDialogComponent } from '../index/show-reason-dialog/show-reason-dialog.component';
import { GetPropertyUrlPipe } from 'app/pipes/get-property-url.pipe';
import { CustomFieldsComponent } from '../components/custom-fields/custom-fields.component';


@Component({
    selector: 'properties-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [GetImageSrcPipe, GetPropertyUrlPipe],
})
export class IndexComponent implements OnInit, OnDestroy {
    @Input() account: any;
    @Input() urbanisation: any;
    @Input() exporter: boolean;
    @Input() projectProps = false;
    @Input() exporterProperties: any;
    @Output() newExporterProperties: EventEmitter<any> = new EventEmitter();
    form: UntypedFormGroup;
    private _unsubscribeAll: Subject<any>;
    loadingResults: boolean;
    title = 'Properties';
    displayedColumns: string[] = [
        'expand',
        'reference',
        'type_one',
        'location',
        'currentprice',
        'bedrooms',
        'status',
        'actions',
    ];
    properties: any = {
        data: [],
    };
    env = environment;
    currentLang: string;
    expandedRow = {} as any;
    currentAgency: any;
    extendSearch = true;
    searchFilters = {} as any;
    routeFilters = {} as any;
    filter = {} as any;
    reloadProperties: EventEmitter<any>;
    accountUpdate: EventEmitter<any>;
    propertySearch: UntypedFormControl = new UntypedFormControl('');
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    expandedAll: boolean;
    searchBy: UntypedFormControl = new UntypedFormControl('reference');
    searchDialogRef: any;
    updateDialogRef: any;
    slidetoggle: UntypedFormControl = new UntypedFormControl();
    selectAll = false;
    selectAllRecords = false;
    selectedItems = [];
    selectedReferences = [];
    selectedMls = [];
    confirmDialogRef: any;
    user: any;
    screenSize: string;

    priceFrom: UntypedFormControl = new UntypedFormControl('');
    priceTo: UntypedFormControl = new UntypedFormControl('');
    defaultRef: string;

    emailed = false;
    interested = false;
    notEmailed = false;
    onlyOwn = false;
    notOwn = false;
    rejection = false;
    scrollClass = '';
    id: any;
    relatedTo = 'property';
    toShow: any;
    excludedBtn = '';
    excludedSearch = false;
    excludedSearchForm: UntypedFormGroup;
    type1Data = [];
    locations = [];
    locationSearch$ = new Subject<string>();

    toggleCurrentPageCheck = false;
    toggleAllPropertiesCheck = false;
    eventData: any;
    dialogRef: any;
    cbSubAgency = false;
    rpaId: any;
    selectAllPages: Boolean = false;
    interestedProps = false;
    rejectionProps = false;
    newReleventProps = false;
    allReleventProps = true;
    customFieldsDialogRef: any;

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _matDialog: MatDialog,
        private router: Router,
        private _propertiesService: PropertiesService,
        private _accountsService: AccountsService,
        private _translateService: TranslateService,
        private _authenticationService: AuthenticationService,
        private _ownersService: OwnersService,
        private _officesService: OfficesService,
        private _attachmentsService: AttachmentsService,
        private _snackBar: MatSnackBar,
        private _getImageSrcPipe: GetImageSrcPipe,
        private _lightbox: Lightbox,
        private _timeLineData: TimeLineDataService,
        private _fuseSidebarService: FuseSidebarService,
        private _globalFuntions: GlobalFuntions,
        private mediaObserver: MediaObserver,
        private route: ActivatedRoute,
        private _dropDownsService: DropdownsService,
        private _propertiesSearchService: PropertiesSearchService,
        private _gService: BaseService,
        private _getPropertyUrlPipe: GetPropertyUrlPipe
    ) {
        this.user = this._authenticationService.currentUserValue;
        this.currentAgency = this._authenticationService.currentAgencyValue;
        this._unsubscribeAll = new Subject();
        this.accountUpdate = new EventEmitter();
        this.reloadProperties = new EventEmitter();
        this.currentLang =
            this._translateService.currentLang === 'es'
                ? 'es_AR'
                : this._translateService.currentLang;
        if (this.currentAgency.pdf_external_ref === 'external_reference') {
            this.defaultRef = 'agency_reference';
        } else if (this.currentAgency.pdf_external_ref === 'agency_reference') {
            this.defaultRef = 'external_reference';
        } else {
            this.defaultRef = 'reference';
        }
        if (this.user?.user_office_data?.is_cb && this.user?.user_role === 'agent_portal') {
            this.searchFilters.status = ['Available', 'Under Offer'];
        } else {
            this.searchFilters.status = ['Available', 'Under Offer', 'Valuation'];
        }
        this.searchFilters.status_not = ['sold'];

        if (includes(this.router.url, 'urbanisation')) {
            this.searchFilters = {};
            this.scrollClass = 'page-layout carded fullwidth';
        } else {
            this.scrollClass = 'page-layout carded fullwidth inner-scroll';
            router.events
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((val: any) => {
                    if (val instanceof NavigationEnd) {
                        this.id = this.route.snapshot.paramMap.get('id');
                        if (this.id) {
                            this._propertiesService
                                .getBookmarkById(this.id)
                                .subscribe((data: any) => {
                                    if (data.search_query.listing_agency) {
                                        data.search_query.listing_agency =
                                            this.currentAgency._id;
                                    }
                                    this.searchFilters = data.search_query;
                                    this.paginator.pageSize = 30;
                                    this.reloadProperties.next(true);
                                });
                        }
                    }
                });
        }

        let officeData = this._authenticationService.currentOfficeValue;
        if (
            !officeData.master_office &&
            officeData.is_cb &&
            this.currentAgency.brochures_only
        ) {
            this.cbSubAgency = true;
        }

        this.route.data.pipe(takeUntil(this._unsubscribeAll)).subscribe((v) => {
            this.relatedTo = v.relatedTo;
            if (v.query) {
                this.routeFilters = v.query;
            }
        });
    }

    ngOnInit(): void {
        if(this.exporter){
            this.searchFilters.status = ['Available', 'Under Offer'];
        }
        this._propertiesSearchService.propertiesSearchData.subscribe(
            (data: any) => {
                if (data && data.type && includes(this.router.url, data.type)) {
                    this.paginator.pageSize = data.pageSize;
                    this.paginator.pageIndex = data.pageIndex;
                    this.searchFilters = data.data;
                }
            }
        );

        setTimeout(() => {
            this._propertiesSearchService.setpropertiesSearchFilter(null);
        }, 1000);

        if (this.relatedTo !== 'archive') {
            if (this.currentAgency.pdf_external_ref === 'external_reference') {
                this.searchBy.setValue('agency_reference');
            }
            if (this.currentAgency.pdf_external_ref === 'agency_reference') {
                this.searchBy.setValue('external_reference');
            }
        }

        this.locationSearch$
            .pipe(
                takeUntil(this._unsubscribeAll),
                switchMap((search: string) => {
                    return this._dropDownsService.getExcludedLocations(
                        50,
                        search
                    );
                })
            )
            .subscribe((data: any) => {
                const locations = mapLodash(data.docs, (item) => {
                    item.label = item.value[this.currentLang];
                    return item;
                });
                this.locations = locations;
            });

        this._translateService.onLangChange.subscribe(() => {
            this.currentLang =
                this._translateService.currentLang === 'es'
                    ? 'es_AR'
                    : this._translateService.currentLang;

            if (this.type1Data.length > 0) {
                const type1Data = mapLodash(this.type1Data, (item) => {
                    item.label = item.value[this.currentLang];
                    return item;
                });
                this.type1Data = type1Data;
            }
            if (this.type1Data.length > 0) {
                const locations = mapLodash(this.locations, (item) => {
                    item.label = item.value[this.currentLang];
                    return item;
                });
                this.locations = locations;
            }
        });

        if (this.account) {
            this.title = 'Relevant properties';
        }
        if (this.exporter) {
            this.toShow = 'showBasket';
            this.title = 'Basket properties';
        }
        if (this.relatedTo === 'archive') {
            this.title = 'Archived Properties';
        } else if (this.relatedTo === 'excluded') {
            this.title = 'Excluded Properties';
            this.displayedColumns = [
                'reference',
                'type_one',
                'location',
                'currentprice',
                'bedrooms',
                'status',
                'actions',
            ];
            this._dropDownsService
                .getPropertyType()
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe((data: any) => {
                    const type1Data = mapLodash(data.body, (item) => {
                        item.label = item.value[this.currentLang];
                        return item;
                    });
                    this.type1Data = type1Data;
                });
            this.excludedSearchForm = this._formBuilder.group({
                property_reference: [],
                agency_reference: [],
                type_one: [],
                currentprice: [],
                bedrooms: [],
                status: [],
                location: [],
            });
        }
        this.mediaObserver
            .asObservable()
            .pipe(
                takeUntil(this._unsubscribeAll),
                filter((changes: MediaChange[]) => changes.length > 0),
                map((changes: MediaChange[]) => changes[0])
            )
            .subscribe((change: MediaChange) => {
                if (change.mqAlias === 'xs') {
                    if (this.relatedTo === 'excluded') {
                        this.displayedColumns = [
                            'reference',
                            'type_one',
                            'status',
                            'actions',
                        ];
                    } else {
                        this.displayedColumns = [
                            'expand',
                            'reference',
                            'status',
                            'actions',
                        ];
                    }
                    this.screenSize = 'xs';
                    this.expandedAll = false;
                    this.expandedRow = {};
                } else if (change.mqAlias === 'sm') {
                    this.screenSize = '';
                    if (this.relatedTo === 'excluded') {
                        this.displayedColumns = [
                            'reference',
                            'type_one',
                            'currentprice',
                            'status',
                            'actions',
                        ];
                    } else {
                        this.displayedColumns = [
                            'expand',
                            'reference',
                            'type_one',
                            'status',
                            'actions',
                        ];
                    }
                } else {
                    this.screenSize = '';
                    if (this.relatedTo === 'excluded') {
                        this.displayedColumns = [
                            'reference',
                            'type_one',
                            'location',
                            'currentprice',
                            'bedrooms',
                            'status',
                            'actions',
                        ];
                    } else {
                        this.displayedColumns = [
                            'expand',
                            'reference',
                            'type_one',
                            'location',
                            'currentprice',
                            'bedrooms',
                            'status',
                            'actions',
                        ];
                    }
                }
            });

        this._translateService.onLangChange
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.currentLang =
                    this._translateService.currentLang === 'es'
                        ? 'es_AR'
                        : this._translateService.currentLang;
            });

        // tslint:disable-next-line: align
        merge(
            this.sort.sortChange,
            this.paginator.page,
            this.reloadProperties,
            this.propertySearch.valueChanges.pipe(
                debounceTime(500),
                tap(() => {
                    // this.searchFilters = {};
                })
            ),
            this._translateService.onLangChange
        )
            .pipe(
                startWith(''),
                tap(() => (this.loadingResults = true)),
                takeUntil(this._unsubscribeAll),
                switchMap(() => {
                    // this.selectAll = false;
                    // this.selectAllRecords = false;
                    // this.selectedItems = [];
                    // this.searchFilters.status_not = ['Sold'];
                    // this.searchFilters.status = ['Available', 'Under Offer', 'Valuation'];
                    if (this.sort.active && this.sort.direction) {
                        this.searchFilters.sort = [
                            this.sort.active,
                            this.sort.direction === 'asc'
                                ? 'SORT_ASC'
                                : 'SORT_DESC',
                        ];
                        if (this.sort.active === 'thisWeek') {
                            this.searchFilters.sort = [
                                'updated_at',
                                'This Week',
                            ];
                        }
                        if (this.sort.active === 'lastThirtyDays') {
                            this.searchFilters.sort = [
                                'updated_at',
                                'Last 30 Days',
                            ];
                        }
                        if (this.sort.active === 'lastThreeMonths') {
                            this.searchFilters.sort = [
                                'updated_at',
                                'Last 3 Months',
                            ];
                        }
                        if (this.sort.active === 'lastSixMonths') {
                            this.searchFilters.sort = [
                                'updated_at',
                                'Last 6 Months',
                            ];
                        }
                        if (this.sort.active === 'lastYear') {
                            this.searchFilters.sort = [
                                'updated_at',
                                'Last Year',
                            ];
                        }
                    }
                    if (!isEmpty(history.state.p_ids)) {
                        delete this.searchFilters.status;
                        delete this.searchFilters.status_not;
                        this.searchFilters._ids = history.state.p_ids;
                    }
                    // if (this.exporter) {
                    //     delete this.searchFilters.status;
                    //     delete this.searchFilters.status_not;
                    // }
                    if (
                        this.searchBy.value === 'currentprice' &&
                        (this.priceFrom.value || this.priceTo.value)
                    ) {
                        this.searchFilters.currentprice = [
                            this.priceFrom.value,
                            this.priceTo.value,
                        ];
                    }
                    if (this.searchBy.value === 'title') {
                        this.searchFilters.search_by = [this.searchBy.value];
                        this.searchFilters.reference =
                            this._globalFuntions.caseAndAccentInsensitive(
                                this.propertySearch.value
                            );
                    }
                    if (this.searchBy.value === 'formatted_address') {
                        this.searchFilters.search_by = [this.searchBy.value];
                        this.searchFilters.reference =
                            this._globalFuntions.caseAndAccentInsensitive(
                                this.propertySearch.value
                            );
                    } else if (
                        this.searchBy.value &&
                        this.propertySearch.value
                    ) {
                        this.searchFilters.reference =
                            this.propertySearch.value;
                        this.searchFilters.search_by = [this.searchBy.value];
                    }
                    // BUSCADOR VERSIÓN 2.0 (JV-6863)
                    if (this.searchFilters.reference) {
                        this.searchFilters.status = [];
                    }
                    if (!isEmpty(this.searchFilters.LG)) {
                        delete this.searchFilters.LG;
                    }
                    if (this.account) {
                        if (!this.searchFilters.status) {
                            this.searchFilters.status = [
                                'Available',
                                'Under Offer',
                            ];
                        }
                        this.searchFilters.relevant_of = this.account._id;
                        this.searchFilters.emailed = this.emailed;
                        // this.searchFilters.rejection = this.rejection;
                        this.searchFilters.own = {
                            only_own: this.onlyOwn,
                            not_own: this.notOwn,
                        };
                        // this.searchFilters.interested = this.interested;
                        this.searchFilters.not_emailed = this.notEmailed;
                        if (this.allReleventProps) {
                            this.interestedProps = false;
                            this.rejectionProps = false;
                            this.newReleventProps = false;
                            this.allReleventProps = true;
                            if (this.account) {
                                // this.searchFilters = { rejection: true, interested: true };
                                this.searchFilters.relevant_of = this.account._id;
                            }
                        }
                    }

                    if (this.exporter && this.toShow === 'showBasket') {
                        if (!isEmpty(this.exporterProperties)) {
                            this.searchFilters._ids = this.exporterProperties;
                        } else {
                            this.searchFilters._ids = ['xyz'];
                        }
                    }

                    if (this.projectProps) {
                        if (!isEmpty(this.exporterProperties)) {
                            this.searchFilters._ids = this.exporterProperties;
                        }
                    }

                    let perPage = 30;
                    if (this.paginator.pageSize) {
                        perPage = this.paginator.pageSize * 1;
                    }
                    if (this.relatedTo === 'archive') {
                        let archiveFilter = {} as any;
                        if (this.searchBy.value && this.propertySearch.value) {
                            archiveFilter = {
                                [this.searchFilters.search_by]:
                                    this.propertySearch.value,
                            };
                        }
                        if (this.sort.active && this.sort.direction) {
                            archiveFilter.sort = [
                                this.sort.active,
                                this.sort.direction === 'asc'
                                    ? 'SORT_ASC'
                                    : 'SORT_DESC',
                            ];
                            if (this.sort.active === 'thisWeek') {
                                archiveFilter.sort = [
                                    'updated_at',
                                    'This Week',
                                ];
                            }
                            if (this.sort.active === 'lastThirtyDays') {
                                archiveFilter.sort = [
                                    'updated_at',
                                    'Last 30 Days',
                                ];
                            }
                            if (this.sort.active === 'lastThreeMonths') {
                                archiveFilter.sort = [
                                    'updated_at',
                                    'Last 3 Months',
                                ];
                            }
                            if (this.sort.active === 'lastSixMonths') {
                                archiveFilter.sort = [
                                    'updated_at',
                                    'Last 6 Months',
                                ];
                            }
                            if (this.sort.active === 'lastYear') {
                                archiveFilter.sort = [
                                    'updated_at',
                                    'Last Year',
                                ];
                            }
                        }
                        return this._propertiesService.getArchiveProperties(
                            archiveFilter,
                            this.paginator.pageIndex + 1,
                            perPage
                        );
                    }
                    if (this.relatedTo === 'excluded') {
                        let excludedFilter = {} as any;
                        if (this.searchBy.value && this.propertySearch.value) {
                            excludedFilter = {
                                [this.searchFilters.search_by]:
                                    this.propertySearch.value,
                            };
                        }
                        if (this.excludedBtn !== '') {
                            excludedFilter.type = this.excludedBtn;
                        }
                        if (
                            this.excludedSearchForm.get('property_reference')
                                .value
                        ) {
                            excludedFilter.property_reference =
                                this.excludedSearchForm.get(
                                    'property_reference'
                                ).value;
                        }
                        if (
                            this.excludedSearchForm.get('agency_reference')
                                .value
                        ) {
                            excludedFilter.agency_reference =
                                this.excludedSearchForm.get(
                                    'agency_reference'
                                ).value;
                        }
                        if (this.excludedSearchForm.get('type_one').value) {
                            excludedFilter.type_one =
                                this.excludedSearchForm.get('type_one').value;
                        }
                        if (this.excludedSearchForm.get('currentprice').value) {
                            excludedFilter.currentprice =
                                this.excludedSearchForm.get(
                                    'currentprice'
                                ).value;
                        }
                        if (this.excludedSearchForm.get('bedrooms').value) {
                            excludedFilter.bedrooms =
                                this.excludedSearchForm.get('bedrooms').value;
                        }
                        if (this.excludedSearchForm.get('status').value) {
                            excludedFilter.status =
                                this.excludedSearchForm.get('status').value;
                        }
                        if (this.excludedSearchForm.get('location').value) {
                            excludedFilter.location =
                                this.excludedSearchForm.get('location').value;
                        }
                        if (this.searchFilters.sort) {
                            excludedFilter.sort = this.searchFilters.sort;
                        }
                        return this._propertiesService.getExcludedProperties(
                            excludedFilter,
                            this.paginator.pageIndex + 1,
                            perPage
                        );
                    }
                    if (!isEmpty(this.routeFilters)) {
                        assignIn(this.searchFilters, this.routeFilters);
                    }
                    if (this.urbanisation) {
                        if (this.searchFilters?.status_not) {
                            delete this.searchFilters?.status_not
                        }
                        return this._propertiesService.getUrbanisationProperties(
                            this.searchFilters,
                            this.urbanisation,
                            this.paginator.pageIndex + 1
                        );
                    } else {
                        this.expandedRow = {};
                        this.expandedAll = false;
                        return this._propertiesService.getData(
                            this.searchFilters,
                            this.paginator.pageIndex + 1,
                            perPage,
                            '',
                            this.currentLang
                        );
                    }
                })
            )
            .subscribe(
                (data: any) => {
                    this.loadingResults = false;
                    if (this.urbanisation) {
                        this.properties.data = data.body.docs;
                        this.properties.total = data.body.total;
                        this.paginator.pageSize = data.body.limit;
                    } else {
                        this.properties.data = data.body;
                        this.properties.total = data.headers.get(
                            'x-pagination-total-count'
                        );
                        this.paginator.pageSize = this.properties.limit =
                            data.headers.get('x-pagination-per-page');
                        if (this.relatedTo === 'excluded') {
                            this.properties.own_count =
                                data.headers.get('Own-Count');
                            this.properties.notown_count =
                                data.headers.get('NotOwn-Count');
                            this.excludedSearch = false;
                        }
                    }
                    if (this.properties.total <= 30) {
                        this.selectAllPages = true;
                    } else {
                        this.selectAllPages = false;
                    }
                    if (!this.selectAllRecords) {
                        this.selectAll = true;
                        this.properties.data.map((property) => {
                            property.web_visibility =
                                this.checkWebVisibility(property);
                            if (
                                this.selectedItems.indexOf(property._id) === -1
                            ) {
                                this.selectAll = false;
                            }
                            return property;
                        });
                    } else {
                        let pageSelection = []
                        forEach(this.properties.data, (property) => {
                            if (this.selectedItems.indexOf(property._id) !== -1) {
                                pageSelection.push(property._id);
                            }
                        });
                        if (pageSelection.length === this.properties.data.length) {
                            this.selectAll = true;
                        } else {
                            this.selectAll = false;
                        }
                    }
                    if (this.exporter && this.toShow === 'showAll') {
                        this.toggleCurrentPage();
                    }
                },
                () => (this.loadingResults = false)
            );

        this.accountUpdate
            .pipe(
                tap(() => (this.loadingResults = true)),
                takeUntil(this._unsubscribeAll),
                switchMap(() => {
                    return this._accountsService.update(this.account);
                })
            )
            .subscribe(
                (data: any) => {
                    this.loadingResults = false;
                    this.reloadProperties.next(true);
                },
                () => (this.loadingResults = false)
            );

        if (
            this.user && !this.account &&
            this.user.user_properties_view &&
            this.user.user_properties_view == 'grid' &&
            this.router.url.toString().indexOf('list') === -1
        ) {
            this.gridView();
        }
    }

    checkUrl(property: any): boolean {
        if (
            (property.url || property.website_url) &&
            ['Available', 'Under Offer'].indexOf(property.status) > -1 &&
            property.basic_info_object &&
            property.basic_info_object[this.currentAgency._id]
        ) {
            if (
                !property.basic_info_object ||
                ['All Websites', 'Our Website'].indexOf(
                    property.basic_info_object[this.currentAgency._id].show_on
                ) > -1
            ) {
                return true;
            }
        }
        return false;
    }

    openAccountsDialog(): void {
        const dialogRef = this._matDialog.open(QuickAddComponent, {
            panelClass: 'event-form-dialog',
            disableClose: false,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                }
            });
    }

    openWhatsApp(property: any): void {
        let url =  this._getPropertyUrlPipe.transform(property,'residential', this.currentLang);
        window.open(`https://api.whatsapp.com/send?text=${url}`, `_blank`);
    }

    openBookings(id): void {
        this._matDialog.open(PropertyBookingsComponent, {
            panelClass: 'booking-dialog',
            disableClose: false,
            data: id,
        });
    }

    sorting(active: any, direction: any): void {
        this.sort.active = active;
        this.sort.direction = direction;
        // this.sort.active = this.defaultRef;
        // this.sort.direction = 'asc';
        this.reloadProperties.next(true);
    }

    expandAll(): void {
        if (this.screenSize !== 'xs') {
            this.expandedAll = !this.expandedAll;
            this.expandedRow = {};
            if (this.expandedAll) {
                forEach(this.properties.data, (property: any) => {
                    this.expandedTbl(property);
                });
            }
        }
    }

    openVirtualTourCode(data: any): void {
        const dialogRef = this._matDialog.open(VirtualTourCodeComponent, {
            panelClass: 'event-form-dialog',
            disableClose: false,
            data: data,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                }
            });
    }

    expandedTbl(property: any): void {
        if (this.screenSize === 'xs') {
            this.searchDialogRef = this._matDialog.open(
                PropertiesDetailsViewComponent,
                {
                    panelClass: 'event-form-dialog',
                    disableClose: false,
                    data: property,
                }
            );
        } else {
            this.expandedRow[property._id] = !this.expandedRow[property._id];
            if (this.expandedRow[property._id]) {
                if (
                    property.private_info_object &&
                    property.private_info_object[this.currentAgency._id] &&
                    property.private_info_object[this.currentAgency._id].owner
                ) {
                    const owner =
                        property.private_info_object[this.currentAgency._id]
                            .owner;
                    if (owner !== 'null') {
                        this._propertiesService
                            .getPropertyOwner(owner, property.created_by)
                            .pipe(takeUntil(this._unsubscribeAll))
                            .subscribe((data: any) => {
                                if (!data.age) {
                                    let age: any = 'N/A';
                                    if (
                                        data.date_of_birth &&
                                        isValid(new Date(data.date_of_birth))
                                    ) {
                                        const dateOfBirth = new Date(
                                            data.date_of_birth
                                        );
                                        const toDay = new Date();
                                        age = differenceInYears(
                                            toDay,
                                            dateOfBirth
                                        );
                                    }
                                    data.age = age;
                                }
                                property.owner_data = data;
                            });
                    }
                }

                if (property.offices) {
                    this._officesService
                        .getAll({ _id: property.offices }, 1, false)
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((data: any) => {
                            property.offices_data = data.body;
                        });
                }
                if (
                    (property.year_built && property.year_built.length <= 4) ||
                    typeof property.year_built == 'number'
                ) {
                    property.year_built =
                        property.year_built + '-01-01T12:00:00+05:00';
                }
                if (property.listing_agent) {
                    this._gService
                        .get(`users/${property.listing_agent}`, 'Yii')
                        .subscribe(
                            (response: any) => {
                                property.listing_agent_data = response;
                            },
                            (err) => {
                                this._gService
                                    .get(
                                        `contacts/${property.listing_agent}`,
                                        'Yii'
                                    )
                                    .subscribe((data: any) => {
                                        property.listing_agent_data = data;
                                    });
                            }
                        );
                }
                if (property.listing_agency) {
                    this._gService
                        .get(`agencies/${property.listing_agency}`, 'Yii')
                        .subscribe(
                            (response: any) => {
                                property.listing_agency_data = response;
                            },
                            (err) => {
                                this._gService
                                    .get(
                                        `companies/${property.listing_agency}`,
                                        'Yii'
                                    )
                                    .subscribe((data: any) => {
                                        property.listing_agency_data = data;
                                    });
                            }
                        );
                }
                if (property.nude_sales && property.nude_sales.length) {
                    property.nude_sales = orderBy(
                        property.nude_sales,
                        ['initial_amount'],
                        ['desc']
                    );
                    const nudeSales = findLast(property.nude_sales, (n) => {
                        return n.initial_amount ? true : false;
                    });
                    if (nudeSales && !isEmpty(nudeSales.initial_amount)) {
                        property.initial_amount = nudeSales.initial_amount;
                    }
                    if (nudeSales && !isEmpty(nudeSales.lft_monthly_rent)) {
                        property.lft_monthly_rent = nudeSales.lft_monthly_rent;
                    }
                    if (
                        nudeSales &&
                        !isEmpty(nudeSales.temporary_monthly_rent)
                    ) {
                        property.temporary_monthly_rent =
                            nudeSales.temporary_monthly_rent;
                    }
                }
                this._attachmentsService
                    .getModelAttachments(property._id, 'properties_images')
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe((data: any) => {
                        if (data.length === 0) {
                            data = [
                                {
                                    document: false,
                                    file_md5_name: 'placeholder-image.png',
                                    model_id: 'root',
                                    model_name: 'any',
                                },
                            ];
                        }
                        property.images = data;
                        property._albums = [];
                        forEach(data, (model: any) => {
                            const album = {
                                src: this._getImageSrcPipe.transform(model),
                                caption: '',
                                thumb: this._getImageSrcPipe.transform(
                                    model,
                                    300
                                ),
                            };
                            property._albums.push(album);
                        });
                    });
            }
        }
    }

    selectedProperties = [];

    selectProperty(property: any, event: any): void {
        const index: number = this.selectedItems.indexOf(property._id);
        const indexMls: number = this.selectedMls.indexOf(property.reference);
        if (index !== -1) {
            this.selectedItems.splice(index, 1);
            this.selectedReferences.splice(index, 1);
            this.selectAll = false;
        }
        if (indexMls !== -1) {
            this.selectedMls.splice(indexMls, 1);
        }
        if (event.checked) {
            this.selectedItems.push(property._id);
            this.selectedReferences.push(property.reference);
            if (property.agency !== this.currentAgency._id) {
                this.selectedMls.push(property.reference);
            }

            this.selectedProperties.push(property);
        } else if (!event.checked) {
            this.selectedProperties = this.selectedProperties.filter(
                (map) => map._id !== property._id
            );
        }
    }
    SelectAll(event: any): void {
        if (event.checked) {
            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < this.properties.data.length; i++) {
                this.selectedItems.push(this.properties.data[i]._id);
                if (this.selectedProperties.length > 0) {
                    this.selectedProperties = this.selectedProperties.filter(property => property?._id !== this.properties.data[i]._id);
                    this.selectedProperties.push(this.properties.data[i]);
                } else {
                    this.selectedProperties.push(this.properties.data[i]);
                }

                if (this.selectedReferences.indexOf(this.properties.data[i].reference) === -1) {
                    this.selectedReferences.push(this.properties.data[i].reference);
                    if (this.properties.data[i].agency !== this.currentAgency._id) {
                        this.selectedMls.push(this.properties.data[i].reference);
                    }
                }
            }
            this.selectedItems = this.selectedItems.filter(
                (item, i, ar) => ar.indexOf(item) === i
            );
        } else {
            for (let i = 0; i < this.properties.data.length; i++) {
                this.selectedItems = this.selectedItems.filter(item => item !== this.properties.data[i]._id);
                this.selectedReferences = this.selectedReferences.filter(reference => reference !== this.properties.data[i].reference);
                if (this.properties.data[i].agency !== this.currentAgency._id) {
                    this.selectedMls = this.selectedMls.filter(reference => reference !== this.properties.data[i].reference);
                }
                this.selectedProperties = this.selectedProperties.filter(property => property._id !== this.properties.data[i]._id);
            }
        }
        if (this.selectedItems.length === this.properties.data.length) {
            this.selectAll = true;
        }
    }

    SelectAllRecords(event: any): void {
        // this is use to select all records #2459
        if (event.checked) {
            this.loadingResults = true;
            this._propertiesService.selectAll(this.searchFilters).subscribe(
                (data: any) => {
                    this.selectedProperties = data;
                    this.selectedItems = mapLodash(data, '_id');

                    this.loadingResults = false;
                    if (
                        data.length === this.properties.data.length ||
                        data.length > this.properties.data.length
                    ) {
                        this.selectAll = true;
                        this.selectAllRecords = true;
                    } else {
                        this.selectAll = false;
                        this.selectAllRecords = false;
                    }
                },
                () => (this.loadingResults = false)
            );
        } else {
            this.selectedItems = [];
            this.selectedProperties = [];
        }
        if (
            this.selectedItems.length === this.properties.data.length ||
            this.selectedItems.length > this.properties.data.length
        ) {
            this.selectAll = true;
            this.selectAllRecords = true;
        } else {
            this.selectAll = false;
            this.selectAllRecords = false;
        }
    }

    openLightbox(_albums: any, index: any): void {
        this._lightbox.open(_albums, index);
    }

    openSearchForm(): void {
        this._fuseSidebarService.getSidebar('srarchForm').toggleOpen();
    }

    openTimeline(property: any): void {
        this._timeLineData.setModelDataValue(property);
        this._timeLineData.setRelatedToValue('property');
        this._fuseSidebarService.getSidebar('timeline').toggleOpen();
    }

    openSequence(property: any): void {
        this._timeLineData.setModelDataValue(property);
        this._timeLineData.setRelatedToValue('property');
        this._fuseSidebarService.getSidebar('timeLine').toggleOpen();
    }

    deleteSelected(propertyIds: any): void {
        this.loadingResults = true;
        this._propertiesService.bulkArchive(propertyIds).subscribe(
            (data: any) => {
                this.expandedAll = false;
                this.expandedRow = {};
                this._snackBar.open(
                    this._translateService.instant('Deleted successfully'),
                    this._translateService.instant('Close'),
                    {
                        duration: 2000,
                    }
                );
                this.loadingResults = false;
                this.selectedItems = [];
                this.selectedReferences = [];
                this.selectedMls = [];
                this.reloadProperties.next(true);
            },
            (err) => {
                this.loadingResults = false;
            }
        );
    }

    deleteProperty(property: any): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant('Are you sure you want to delete?');
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    if (this.relatedTo !== 'archive') {
                        const data = {
                            delete_flag: false,
                        };
                        property.delete_flag = true;
                        this._propertiesService
                            .updateProperty(property._id, property)
                            .subscribe(() => {
                                this.expandedAll = false;
                                this.expandedRow = {};
                                this._snackBar.open(
                                    this._translateService.instant(
                                        'Archive successfully'
                                    ),
                                    this._translateService.instant('Close'),
                                    {
                                        duration: 2000,
                                    }
                                );
                                this._gService
                                    .post(
                                        `properties/save-history?id=${property._id}&reference=${property.refernce}&model=property`,
                                        data,
                                        'yii'
                                    )
                                    .subscribe((response: any) => {});
                                this.refresh(this.paginator.pageIndex);
                            });
                    } else {
                        this._propertiesService
                            .deleteArchiveProperty(
                                property._id,
                                property.created_by,
                                property.agency
                            )
                            .subscribe(() => {
                                this.expandedAll = false;
                                this.expandedRow = {};
                                this._snackBar.open(
                                    this._translateService.instant(
                                        'Deleted successfully'
                                    ),
                                    this._translateService.instant('Close'),
                                    {
                                        duration: 2000,
                                    }
                                );
                                this.refresh(this.paginator.pageIndex);
                            });
                    }
                }
            });
    }

    onSubmitSearchForm(event: UntypedFormGroup): void {
        this.eventData = event.value;
        const ownCheck: any = this._globalFuntions.clearObject(this.eventData);
        if (ownCheck.own) {
            ownCheck.own.not_own = ownCheck.own.not_own
                ? ownCheck.own.not_own
                : false;
            ownCheck.own.only_own = ownCheck.own.only_own
                ? ownCheck.own.only_own
                : false;
        }
        this._fuseSidebarService.getSidebar('srarchForm').toggleOpen();
        this.searchFilters = ownCheck;
        this.priceFrom.setValue(null, { emitEvent: false });
        this.priceTo.setValue(null, { emitEvent: false });
        this.propertySearch.setValue(null, { emitEvent: false });
        this.reloadProperties.next(true);
    }

    refresh(page?: any): void {
        page
            ? (this.paginator.pageIndex = page)
            : (this.paginator.pageIndex = 0);
        this.searchFilters = {};
        if (this.user?.user_office_data?.is_cb && this.user?.user_role === 'agent_portal') {
            this.searchFilters.status = ['Available', 'Under Offer'];
        } else {
            this.searchFilters.status = ['Available', 'Under Offer', 'Valuation'];
        }
        this.selectAllRecords = false;
        this.selectAll = false;
        this.selectedItems = [];
        this.selectedProperties = [];
        this.selectedReferences = [];
        this.selectedMls = [];
        this.searchFilters.status_not = ['sold'];
        this.sort.active = null;
        this.sort.direction = '';
        this.propertySearch.setValue(null, { emitEvent: false });
        this.priceFrom.setValue(null, { emitEvent: false });
        this.priceTo.setValue(null, { emitEvent: false });
        this.reloadProperties.next(true);
    }

    gridView(): void {
        const searchFilter = {
            type: '/grid',
            data: this.searchFilters,
            pageIndex: 0,
            pageSize: 30,
        };

        if (includes(this.router.url, 'own')) {
            this.router.navigateByUrl('/properties/own-grid');
            searchFilter.type = 'own-grid';
        } else if (includes(this.router.url, 'sales')) {
            this.router.navigateByUrl('/properties/sales-grid');
            searchFilter.type = 'sales-grid';
        } else if (includes(this.router.url, 'rentals')) {
            this.router.navigateByUrl('/properties/rentals-grid');
            searchFilter.type = 'rentals-grid';
        } else {
            this.router.navigateByUrl('/properties/grid');
        }
        this.calculateGridPage(searchFilter);
        this._propertiesSearchService.setpropertiesSearchFilter(searchFilter);
    }

    calculateGridPage(searchFilter: any): void {
        let pageSize = 30;
        let pageIndex = 0;
        pageIndex = floor(
            (this.paginator.pageSize * this.paginator.pageIndex) / pageSize
        );
        searchFilter.pageIndex = pageIndex;
        searchFilter.pageSize = pageSize;
    }

    viewProperty(id: string): void {
        const searchFilter = {
            type: 'index',
            data: this.searchFilters,
            pageIndex: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize,
        };
        if (includes(this.router.url, 'own')) {
            this.router.navigateByUrl('/properties/view/' + id, {
                state: { route: '/properties/own' },
            });
            searchFilter.type = 'own';
        } else if (includes(this.router.url, 'sales')) {
            this.router.navigateByUrl('/properties/view/' + id, {
                state: { route: '/properties/sales' },
            });
            searchFilter.type = 'sales';
        } else if (includes(this.router.url, 'rentals')) {
            this.router.navigateByUrl('/properties/view/' + id, {
                state: { route: '/properties/rentals' },
            });
            searchFilter.type = 'rentals';
        } else if (includes(this.router.url, 'excluded')) {
            this.router.navigateByUrl('/properties/view/' + id, {
                state: { route: '/properties/excluded' },
            });
            searchFilter.type = 'excluded';
        } else {
            this.router.navigateByUrl('/properties/view/' + id);
        }
        this._propertiesSearchService.setpropertiesSearchFilter(searchFilter);
    }

    openProperties(property: any): void {
        this.rpaId = property._id;
        this._fuseSidebarService.getSidebar('properties-view').toggleOpen();
    }
    editProperty(id: string, propertyAgency: string = ''): void {
        if (propertyAgency == this.env.casafariAgency && this.currentAgency._id !== this.env.casafariAgency) {
            let index = this.properties?.data.findIndex(x => x._id == id);
            if (index != -1) {
                let prop = this.properties.data[index];
                prop = this._globalFuntions.cleanObject(prop);
                let custom_fields = [];
                if (prop.hasOwnProperty('private_info_object') &&
                    prop?.private_info_object?.hasOwnProperty(this.user.user_agency) &&
                    prop?.private_info_object?.[this.user.user_agency]?.hasOwnProperty('custom_fields')
                ) {
                    custom_fields = prop.private_info_object[this.user.user_agency]['custom_fields'];
                }
                this.customFieldsDialogRef = this._matDialog.open(CustomFieldsComponent, {
                    panelClass: 'mass-dialog',
                    data: {
                     "custom_fields": custom_fields,
                     "custom_categories":   prop?.custom_categories,
                     "agency_custom_categories": prop?.private_info_object[this.user.user_agency]?.agency_custom_categories
                    }
                });
                this.customFieldsDialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        if(!prop?.private_info_object){
                            prop['private_info_object'] = {
                                [this.user.user_agency] : {}
                            };
                        }else if (!prop?.private_info_object?.hasOwnProperty(this.user.user_agency)) {
                            prop['private_info_object'][this.user.user_agency] = {};
                        }
                        prop.private_info_object[this.user.user_agency]['custom_fields'] = result?.fields;
                        prop.private_info_object[this.user.user_agency]['agency_custom_categories'] = result?.agency_custom_categories;
                        prop.from_cron = true;
                        this._propertiesService
                            .updateProperty(id, prop)
                            .subscribe(
                                (data: any) => {
                                    this._snackBar.open(
                                        this._translateService.instant('Updated successfully'),
                                        this._translateService.instant('Close'),
                                        {
                                            duration: 2000,
                                        }
                                    );
                                }
                            );
                    }
                })
            }
        } else {
            const searchFilter = {
                type: 'index',
                data: this.searchFilters,
                pageIndex: this.paginator.pageIndex,
                pageSize: this.paginator.pageSize,
            };
            if (includes(this.router.url, 'own')) {
                this.router.navigateByUrl('/properties/update/' + id, {
                    state: { route: '/properties/own' },
                });
                searchFilter.type = 'own';
            } else if (includes(this.router.url, 'sales')) {
                this.router.navigateByUrl('/properties/update/' + id, {
                    state: { route: '/properties/sales' },
                });
                searchFilter.type = 'sales';
            } else if (includes(this.router.url, 'rentals')) {
                this.router.navigateByUrl('/properties/update/' + id, {
                    state: { route: '/properties/rentals' },
                });
                searchFilter.type = 'rentals';
            } else {
                this.router.navigateByUrl('/properties/update/' + id);
            }
            this._propertiesSearchService.setpropertiesSearchFilter(searchFilter);
        }
    }

    changeStatus(property: any): void {
        if (
            typeof property.basic_info_object[this.currentAgency._id] ===
            'undefined'
        ) {
            property.basic_info_object[this.currentAgency._id] = {
                show_on: 'All Websites',
            };
        }
        if (
            property.status === 'Available' &&
            (property.basic_info_object[this.currentAgency._id].show_on ===
                'All Websites' ||
                property.basic_info_object[this.currentAgency._id].show_on ===
                    'Our Website')
        ) {
            property.basic_info_object[this.currentAgency._id].show_on = 'None';
            property.status = 'Available';
        } else if (
            property.status === 'Unavailable' &&
            (property.basic_info_object[this.currentAgency._id].show_on ===
                'All Websites' ||
                property.basic_info_object[this.currentAgency._id].show_on ===
                    'Our Website')
        ) {
            property.basic_info_object[this.currentAgency._id].show_on =
                'All Websites';
            property.status = 'Available';
        } else if (
            (property.status === 'Unavailable' ||
                property.status === 'Available') &&
            property.basic_info_object[this.currentAgency._id].show_on ===
                'None'
        ) {
            property.basic_info_object[this.currentAgency._id].show_on =
                'All Websites';
            property.status = 'Unavailable';
        }
        this._propertiesService
            .updateProperty(property._id, property)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.loadingResults = true;
                this.reloadProperties.next(true);
            });
    }

    dateDiff(date: any): any {
        if (date) {
            const toDay = new Date();
            const propertyDate = new Date(date);
            const magicNumber = 1000 * 60 * 60 * 24;
            const days = Math.round(
                Math.abs(
                    (toDay.getTime() - propertyDate.getTime()) / magicNumber
                )
            );
            const weeks = Math.round(days / 7);
            const months = Math.round(weeks / 4);
            const years = Math.round(months / 12);
            return {
                years: years,
                months: months,
                weeks: weeks,
                days: days,
            };
        } else {
            return 'Not updated';
        }
    }
    trafficLight(property: any): void {
        const dialogRef = this._matDialog.open(TrafficLightComponent, {
            panelClass: 'traffic-light-dialog',
            // disableClose: false,
            data: property,
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                    // this.refresh();
                }
            });
    }

    showDuplications(property: any): void {
        const dialogRef = this._matDialog.open(PropertyDuplicationsComponent, {
            panelClass: 'property-duplications-dialog',
            data: property,
        });

        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                    // this.refresh();
                }
            });
    }

    updateFeature(propertiesCopy: any, property: any): void {
        if (propertiesCopy === null || propertiesCopy === 'undefined') {
            propertiesCopy = {
                featured: true,
                property_id: property._id,
            };
            this._propertiesService.insertPC(propertiesCopy).subscribe(() => {
                this.reloadProperties.next(true);
            });
        } else {
            propertiesCopy.featured = !propertiesCopy.featured;
            propertiesCopy.property_id = property._id;
            this._propertiesService.updatePC(propertiesCopy).subscribe(() => {
                this.reloadProperties.next(true);
            });
        }
    }

    removeFromlist(id: any): void {
        this._propertiesService.RemoveFromList(id).subscribe(() => {
            this.reloadProperties.next(true);
        });
    }

    addToList(id: any): void {
        this._propertiesService.AddToList(id).subscribe(() => {
            this.reloadProperties.next(true);
        });
    }

    excludePropertyInterest(property, account): void {
        if (account.properties_interested.indexOf(property.reference) > -1) {
            const index = account.properties_interested.indexOf(
                property.reference
            );
            account.properties_interested.splice(index, 1);
            this.accountUpdate.next(true);
            this.expandedRow = {};
        }
    }

    includePropertyInterest(property, account): void {
        if (account.properties_interested) {
            account.properties_interested.push(property.reference);
        } else {
            account.properties_interested = [property.reference];
        }
        this.accountUpdate.next(true);
        this.expandedRow = {};
    }

    ifIsInterested(property, account): boolean {
        if (property && account) {
            return account.indexOf(property) > -1;
        } else {
            return false;
        }
    }

    rejectProperty(property): void {
        const dialog = this._matDialog.open(RejectAccountComponent, {
            disableClose: true,
        });
        dialog.afterClosed().subscribe((result) => {
            if (result) {
                const excludeFilter = {
                    account: this.account,
                    commercial: false,
                    message: result,
                    property: property,
                };
                this._accountsService
                    .excludeProperty(excludeFilter)
                    .pipe(takeUntil(this._unsubscribeAll))
                    .subscribe((data: any) => {
                        this.reloadProperties.next(true);
                    });
            }
        });
    }

    reIncludeProperty(property): void {
        const excludeFilter = {
            account: this.account,
            property: property,
        };
        this._accountsService
            .reIncludeProperty(excludeFilter)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((data: any) => {
                this.reloadProperties.next(true);
            });
    }

    /* BUTTON FUNCTIONS */

    makeCopy(property: any): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant(
                'Are you sure? The action will duplicate the property!'
            );
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    property.created_by = this.user.user_id;
                    property.created_at = new Date();
                    property.user_copy = true;
                    property.local = true;
                    if (property.agency != this.currentAgency._id && this.user.user_role !== 'admin') {
                        property.agency = this.currentAgency._id;
                        property.user_copy = false;
                    }
                    if (
                        property.private_info_object &&
                        property.private_info_object[this.currentAgency._id] &&
                        property.private_info_object[this.currentAgency._id]
                            .cadastral_numbers
                    ) {
                        delete property.private_info_object[
                            this.currentAgency._id
                        ].cadastral_numbers;
                    }
                    this._propertiesService
                        .createCopy(property)
                        .subscribe((data: any) => {
                            this._propertiesService
                                .copyAttachments(property._id, data._id)
                                .subscribe(() => {
                                    this._snackBar.open(
                                        this._translateService.instant(
                                            'Copy created successfully'
                                        ),
                                        this._translateService.instant('Close'),
                                        {
                                            duration: 2000,
                                        }
                                    );
                                    this.router.navigate([
                                        '/properties/update/' + data._id,
                                    ]);
                                });
                        });
                }
            });
    }

    disableFunction(createdBy: any, agency: any, cron: any): boolean {
        if (this.user.user_role === 'agent') {
            return false;
        } else {
            if (this.user.user_agency === agency) {
                if (
                    this.user.user_role === 'admin' ||
                    this.user.user_role === 'agency_admin' ||
                    this.user.user_role === 'admin_light'
                ) {
                    return true;
                }
                if (!cron && this.user.user_role === 'agency_manager') {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.user.user_id === createdBy) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }

    restore(data?: any): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant('Are you sure you want to restore?');
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    const delData = {
                        delete_flag: true,
                    };
                    data.delete_flag = false;
                    this._propertiesService
                        .restoreArchiveProperty(data._id, data)
                        .pipe(
                            tap(() => (this.loadingResults = true)),
                            takeUntil(this._unsubscribeAll)
                        )
                        .subscribe(
                            () => {
                                this._gService
                                    .post(
                                        `properties/save-history?id=${data._id}&reference=${data.refernce}&model=property`,
                                        delData,
                                        'yii'
                                    )
                                    .subscribe((response: any) => {});
                                this.loadingResults = false;
                                this.refresh();
                            },
                            () => (this.loadingResults = false)
                        );
                }
            });
    }

    restoreSelected(): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant('Are you sure you want to restore?');
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    const restoreFilter = this.selectedItems.reduce(
                        (acc, elem) => {
                            acc[elem] = true;
                            return acc;
                        },
                        {}
                    );
                    this._propertiesService
                        .restoreSelectedProperties(restoreFilter)
                        .pipe(
                            tap(() => (this.loadingResults = true)),
                            takeUntil(this._unsubscribeAll)
                        )
                        .subscribe(
                            () => {
                                this.loadingResults = false;
                                this.refresh();
                            },
                            () => (this.loadingResults = false)
                        );
                }
            });
    }

    deletedSelected(): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant(
                'Are you sure you want to delete permanently?'
            );
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    const restoreFilter = this.selectedItems.reduce(
                        (acc, elem) => {
                            acc[elem] = true;
                            return acc;
                        },
                        {}
                    );
                    this._propertiesService
                        .deleteSeletedArchiveProperties(restoreFilter)
                        .pipe(
                            tap(() => (this.loadingResults = true)),
                            takeUntil(this._unsubscribeAll)
                        )
                        .subscribe(
                            () => {
                                this.loadingResults = false;
                                this._snackBar.open(
                                    this._translateService.instant(
                                        'Data will be deleted Shortlly.'
                                    ),
                                    this._translateService.instant('Close'),
                                    {
                                        duration: 2000,
                                    }
                                );
                                // this.refresh();
                            },
                            () => (this.loadingResults = false)
                        );
                }
            });
    }

    restoreAll(): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant('Are you sure you want to restore?');
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    this._propertiesService
                        .restoreAll(
                            this._authenticationService.currentAgencyValue._id
                        )
                        .pipe(
                            tap(() => (this.loadingResults = true)),
                            takeUntil(this._unsubscribeAll)
                        )
                        .subscribe(
                            () => {
                                this.loadingResults = false;
                                this.refresh();
                            },
                            () => (this.loadingResults = false)
                        );
                }
            });
    }
    deleteAll(): void {
        this.confirmDialogRef = this._matDialog.open(
            FuseConfirmDialogComponent,
            {
                disableClose: false,
            }
        );
        this.confirmDialogRef.componentInstance.confirmMessage =
            this._translateService.instant(
                'Are you sure you want to delete permanently?'
            );
        this.confirmDialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result: any) => {
                if (result) {
                    this._propertiesService
                        .deleteAll(
                            this._authenticationService.currentAgencyValue._id
                        )
                        .pipe(
                            tap(() => (this.loadingResults = true)),
                            takeUntil(this._unsubscribeAll)
                        )
                        .subscribe(
                            () => {
                                this.loadingResults = false;
                                this._snackBar.open(
                                    this._translateService.instant(
                                        'Data will be deleted Shortlly.'
                                    ),
                                    this._translateService.instant('Close'),
                                    {
                                        duration: 2000,
                                    }
                                );
                                // this.refresh();
                            },
                            () => (this.loadingResults = false)
                        );
                }
            });
    }

    removeFromBasket(toRemove: any): void {
        if (toRemove === 'all') {
            this.exporterProperties = [];
            this.newExporterProperties.next(this.exporterProperties);
            this.loadingResults = true;
            this.reloadProperties.next(true);
        } else {
            const index = indexOf(this.exporterProperties, toRemove);
            this.exporterProperties.splice(index, 1);
            this.exporterProperties = [...this.exporterProperties];
            this.newExporterProperties.next(this.exporterProperties);
            this.loadingResults = true;
            this.reloadProperties.next(true);
        }
    }

    addToBasket(event: any, property: any): void {
        const index = indexOf(this.exporterProperties, property);
        if (event.checked && index < 0) {
            this.exporterProperties = [...this.exporterProperties, property];
        }
        if (!event.checked && index > -1) {
            this.exporterProperties.splice(index, 1);
            this.exporterProperties = [...this.exporterProperties];
        }
        this.newExporterProperties.next(this.exporterProperties);
        this.loadingResults = true;
        this.reloadProperties.next(true);
        this.expandedRow = {};
        this.expandedAll = false;
    }

    toggleAllToBasket(event: any): void {
        this.SelectAll({ checked: true });

        this.selectedItems.forEach((property) => {
            const index = indexOf(this.exporterProperties, property);
            if (event.checked && index < 0) {
                this.exporterProperties = [
                    ...this.exporterProperties,
                    property,
                ];
            }
            if (!event.checked && index > -1) {
                this.exporterProperties.splice(index, 1);
                this.exporterProperties = [...this.exporterProperties];
            }
        });

        this.newExporterProperties.next(this.exporterProperties);
        this.loadingResults = true;
        this.reloadProperties.next(true);
    }

    toggleAllPropertiesToBasket(event: any): void {
        this._propertiesService.selectAll(this.searchFilters).subscribe(
            (data: any) => {
                this.selectedItems = data;
                this.loadingResults = false;
                if (
                    data.length === this.properties.data.length ||
                    data.length > this.properties.data.length
                ) {
                    this.selectAll = true;
                    this.selectAllRecords = true;
                } else {
                    this.selectAll = false;
                    this.selectAllRecords = false;
                }
                this.selectedItems.forEach((property) => {
                    const index = indexOf(
                        this.exporterProperties,
                        property._id
                    );
                    if (event.checked && index < 0) {
                        this.exporterProperties = [
                            ...this.exporterProperties,
                            property._id,
                        ];
                    }
                    if (!event.checked && index > -1) {
                        this.exporterProperties.splice(index, 1);
                        this.exporterProperties = [...this.exporterProperties];
                    }
                });

                this.newExporterProperties.next(this.exporterProperties);
                this.loadingResults = true;
                this.reloadProperties.next(true);
            },
            () => (this.loadingResults = false)
        );
    }

    onToggleShow(toShow: MatButtonToggleGroup): void {
        delete this.searchFilters._ids;
        this.toShow = toShow.value;
        this.loadingResults = true;
        this.reloadProperties.next(true);
    }

    toggleCurrentPage(): void {
        let check = true;
        this.SelectAll({ checked: true });
        this.selectedItems.forEach((element) => {
            if (this.exporterProperties?.indexOf(element) === -1) {
                this.toggleCurrentPageCheck = false;
                check = false;
            }
        });
        if (
            this.selectedItems.length === 0 ||
            this.exporterProperties?.length === 0
        ) {
            this.toggleCurrentPageCheck = false;
            check = false;
        }
        if (check) {
            this.toggleCurrentPageCheck = true;
        }
        this.toggleAllPages();
    }

    toggleAllPages(): void {
        let check = true;
        this._propertiesService.selectAll(this.searchFilters).subscribe(
            (data: any) => {
                this.loadingResults = false;
                data.forEach((element) => {
                    if (this.exporterProperties?.indexOf(element._id) === -1) {
                        this.toggleAllPropertiesCheck = false;
                        check = false;
                    }
                });
                if (
                    data.length === 0 ||
                    this.exporterProperties?.length === 0
                ) {
                    this.toggleAllPropertiesCheck = false;
                    check = false;
                }
                if (check) {
                    this.toggleAllPropertiesCheck = true;
                }
            },
            () => (this.loadingResults = false)
        );
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
    ShowMap(): any {
        const dialog = this._matDialog.open(AllPropertiesShowOnMapComponent, {
            panelClass: 'event-form-dialog',
            disableClose: false,
            maxWidth: '95vw',
            maxHeight: '95vh',
            height: '95%',
            width: '95%',
            data: { data: this.selectedProperties, type: 'residentials' },
        });
        dialog.afterClosed().subscribe((response: any) => {
            const pids = [];
            const polygons = response[0];
            const properties = response[1];

            if (properties.length > 0 && polygons.length > 0) {
                forEach(properties, (property) => {
                    forEach(polygons, (polygon: any) => {
                        // tslint:disable-next-line: max-line-length
                        if (
                            property.private_info_object &&
                            property.private_info_object[
                                this.currentAgency._id
                            ] &&
                            property.private_info_object[this.currentAgency._id]
                                .latitude &&
                            property.private_info_object[this.currentAgency._id]
                                .longitude
                        ) {
                            if (!isEmpty(polygon)) {
                                // tslint:disable-next-line: max-line-length
                                const isMatched = this.isLatLngInZone(
                                    polygon,
                                    property.private_info_object[
                                        this.currentAgency._id
                                    ].latitude,
                                    property.private_info_object[
                                        this.currentAgency._id
                                    ].longitude
                                );
                                if (isMatched) {
                                    pids.push(property._id);
                                }
                            }
                        }
                    });
                });
            }
            if (pids.length > 0) {
                this.searchFilters.pids = pids;
            } else {
                this.searchFilters.pids = ['xyz'];
            }

            this.reloadProperties.next(true);
        });
    }

    isLatLngInZone(latLngs: any, lat: any, lng: any): boolean {
        const verticesY = [];
        const verticesX = [];
        const longitudeX = lng;
        const longitudeY = lat;
        let r = 0;
        let i = 0;
        let j = 0;
        let c = false;
        let point = 0;

        for (r = 0; r < latLngs.length; r++) {
            verticesY.push(latLngs[r].lat);
            verticesX.push(latLngs[r].lng);
        }
        const pointsPolygon = verticesX.length;
        for (i = 0, j = pointsPolygon; i < pointsPolygon; j = i++) {
            point = i;
            if (point === pointsPolygon) {
                point = 0;
            }

            if (
                verticesY[point] > longitudeY !== verticesY[j] > longitudeY &&
                longitudeX <
                    ((verticesX[j] - verticesX[point]) *
                        (longitudeY - verticesY[point])) /
                        (verticesY[j] - verticesY[point]) +
                        verticesX[point]
            ) {
                c = !c;
            }
        }
        return c;
    }

    sendEmail(email: any): void {
        if (email && typeof email !== 'undefined') {
            window.location.href = 'mailto:' + email;
        }
    }

    openCommonDialog(phone: any, propertyUrl?: any): void {
        const mobileData = {
            mobile: phone,
            url: propertyUrl,
        };
        const dialog = this._matDialog.open(CommonDialogComponent, {
            disableClose: false,
            panelClass: 'common-dialog',
            data: mobileData,
        });
        dialog
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response) {
                }
            });
    }

    navigate(): void {
        this._matDialog.open(PropertiesPrintEmailComponent, {
            panelClass: 'pdf-dialog',
            data: {
                selectedItems: this.selectedItems,
                account: this.account,
            },
            disableClose: true,
        });

        // this.router.navigate(['/properties/print-pdf'], { state: { data: this.selectedItems, account: this.account } });
    }

    showVideo(property) {
        if (property?.videos && property?.videos.length) {
            let videos = [];
            forEach(property?.videos, (data) => {
                if (data?.type && data.type === 'Video') {
                    videos.push(data);
                }
            });
            if (videos.length) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    viewingRequest(property: any): void {
        let shared = false;
        if (this.user.user_agency !== property.agency) {
            shared = true;
        }
        this.dialogRef = this._matDialog.open(ViewingToursModalComponent, {
            panelClass: 'event-form-dialog',
            data: {
                prop_id: property._id,
                ref: property.reference,
                shared: shared,
            },
        });
        this.dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response: any) => {
                if (response) {
                    // this.dataReload.setValue('refresh');
                }
            });
    }

    canChange(property: any): boolean {
        const currentUser = this._authenticationService.currentUserValue;
        if (currentUser.user_role === 'agent') {
            return false;
        }
        if (
            currentUser.user_role === 'agent_medium' &&
            currentUser._id !== property.listing_agent
        ) {
            return false;
        }
        return true;
    }

    mobile(owner: any, phone: any): void {
        if (owner.mobile && typeof owner.mobile !== 'undefined') {
            this.confirmDialogRef = this._matDialog.open(
                FuseConfirmDialogComponent,
                {
                    disableClose: false,
                }
            );
            this.confirmDialogRef.componentInstance.confirmMessage =
                'Are you sure you want to make call?';
            this.confirmDialogRef.afterClosed().subscribe((result: any) => {
                if (result) {
                    const data = {
                        type: 'owner',
                        model: 'Owners',
                        activity_type: 'Call to owner',
                        _id: owner._id,
                        mobile: phone,
                    };
                    this._globalFuntions.onCallMobile(data, phone);
                }
            });
        }
    }

    ownText(property): any {
        if (property.own && this.user.user_agency === property.agency) {
            return 'text-truncate font-weight-900';
        } else {
            return 'text-truncate';
        }
    }

    bgColor(property): any {
        if (
            property &&
            property.own &&
            property.mls &&
            (!property.private_info_object ||
                !property.private_info_object[this.currentAgency._id] ||
                !property.private_info_object[this.currentAgency._id]
                    .cadastral_numbers ||
                !property.private_info_object[this.currentAgency._id]
                    .cadastral_numbers[0] ||
                !property.private_info_object[this.currentAgency._id]
                    .cadastral_numbers[0].cadastral_number ||
                property.private_info_object[this.currentAgency._id]
                    .cadastral_numbers[0].cadastral_number == '' ||
                !property.private_info_object[this.currentAgency._id]
                    .latitude ||
                property.private_info_object[this.currentAgency._id].latitude ==
                    '' ||
                !property.private_info_object[this.currentAgency._id]
                    .longitude ||
                property.private_info_object[this.currentAgency._id]
                    .longitude == '' ||
                (property.sale &&
                    property.share_sale &&
                    (!property.private_info_object[this.currentAgency._id]
                        .commission_unit ||
                        property.private_info_object[this.currentAgency._id]
                            .commission_unit == '') &&
                    (!property.commission_notes ||
                        property.commission_notes == '')) ||
                (property.rent &&
                    property.lt_rental &&
                    property.share_rent &&
                    (!property.ltr ||
                        !property.ltr.commission_unit ||
                        property.ltr.commission_unit == '') &&
                    (!property.ltr.commission_notes ||
                        property.ltr.commission_notes == '')) ||
                (property.rent &&
                    property.st_rental &&
                    property.share_rent &&
                    (!property.rental_commission ||
                        property.rental_commission == '') &&
                    (!property.rental_commission_notes ||
                        property.rental_commission_notes == '')))
        ) {
            return 'bg-light-purple';
        } else if (
            property &&
            property.own &&
            property.mls &&
            this.user.user_agency === property.agency
        ) {
            return 'bg-light-green';
        } else if (property && !property.own && property.mls) {
            return 'bg-light-red';
        } else {
            return;
        }
    }

    changeWebPublishing(property): any {
        if (property?.basic_info_object == 'undefined') {
            property.basic_info_object = {};
        }

        let form_data = { show_on: 'None' };
        if (
            property?.basic_info_object?.[this.currentAgency._id]?.show_on ==
            'None'
        ) {
            form_data.show_on = 'All Websites';
        }

        this._propertiesService
            .changeWebPublishing({
                property: property._id,
                form_data: form_data,
            })
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((res) => {
                if (res.success) {
                    this.loadingResults = true;
                    this.reloadProperties.next(true);
                    this._snackBar.open(
                        this._translateService.instant(
                            'Your property is updated.'
                        ),
                        this._translateService.instant('Close'),
                        {
                            duration: 4000,
                        }
                    );
                } else {
                    this._snackBar.open(
                        this._translateService.instant(
                            'Error occoured while updating data.'
                        ),
                        this._translateService.instant('Close'),
                        {
                            duration: 4000,
                        }
                    );
                }
            });
    }

    checkWebVisibility(property): any {
        if (property?.mls_show_on == 'Our Website') {
            return false;
        } else if (
            property?.basic_info_object?.[this.currentAgency._id]?.show_on ==
            'None'
        ) {
            return false;
        } else if (this.currentAgency?.default_show_on_mls == 'not_on_web') {
            if (
                property?.basic_info_object?.[this.currentAgency._id]
                    ?.show_on == 'All Websites'
            ) {
                return true;
            }
            return false;
        }

        return true;
    }

    makeReservation(property): any {
        const dialogRef = this._matDialog.open(PropertyReservationComponent, {
            panelClass: 'property-reservation',
            disableClose: false,
            data: property,
        });
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                    this._snackBar.open(
                        this._translateService.instant('Updated successfully'),
                        this._translateService.instant('Close'),
                        {
                            duration: 2000,
                        }
                    );
                }
            });
    }

    makeAccount(property): any {
        const dialogRef = this._matDialog.open(
            ClientRegistrationRequestComponent,
            {
                panelClass: 'client-registration',
                disableClose: false,
                data: property,
            }
        );
        dialogRef
            .afterClosed()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((result) => {
                if (result) {
                    this._snackBar.open(
                        this._translateService.instant(
                            'Client registration request send successfully!'
                        ),
                        this._translateService.instant('Close'),
                        {
                            duration: 2000,
                        }
                    );
                }
            });
    }

    show_excluded_reason(id) {
        let selectedProperty;
        for (let i = 0; i < this.properties.data.length; i++) {
            if (this.properties.data[i]._id === id) {
                selectedProperty = this.properties.data[i];
            }
        }

        this._propertiesService
            .getExcludedPropertiesReason(id)
            .subscribe((res: any) => {
                const dialogRef = this._matDialog.open(
                    ShowReasonDialogComponent,
                    {
                        panelClass: 'show-reason-dialog',
                        width: '50%',
                        disableClose: false,
                        data: {
                            res: res,
                            property: selectedProperty,
                        },
                    }
                );
            });
    }

    isExcludedRoute(): boolean {
        if (this.router.url.split('/').includes('excluded')) return true;
        else return false;
    }

    interestedProperties(account) {
        this.interestedProps = true;
        this.rejectionProps = false;
        this.newReleventProps = false;
        this.allReleventProps = false;
        if (account) {
            this.searchFilters = { interested:true };
            this.searchFilters.relevant_of = this.account._id;
            this.reloadProperties.next(true);
        }
    }

    rejectedProperties(account){
        this.interestedProps = false;
        this.rejectionProps = true;
        this.newReleventProps = false;
        this.allReleventProps = false;
        if (account) {
            this.searchFilters = { rejection:true };
            this.searchFilters.relevant_of = this.account._id;
            this.reloadProperties.next(true);
        }
    }
    newRelevent(account){
        this.interestedProps = false;
        this.rejectionProps = false;
        this.newReleventProps = true;
        this.allReleventProps = false;  
        if (account) {
            this.searchFilters = { newRelevent:true };
            this.searchFilters.relevant_of = this.account._id;
            this.reloadProperties.next(true);
        }
    }
    allRelevent(account){
        this.interestedProps = false;
        this.rejectionProps = false;
        this.newReleventProps = false;
        this.allReleventProps = true; 
        if (account) {
            // this.searchFilters.interested = true;
            this.searchFilters = { rejection:true , interested:true };
            this.searchFilters.relevant_of = this.account._id;
            this.reloadProperties.next(true);
        }
    }
}
